import SparkMD5 from 'spark-md5';
import { hexToBase64 } from '../utils';

const CHUNK_SIZE = 2097152;

export const checksum = (file: File): Promise<{ hex: string; base64: string }> =>
  new Promise((resolve, reject) => {
    let currentChunk = 0;
    const chunks = Math.ceil(file.size / CHUNK_SIZE);
    const spark = new SparkMD5.ArrayBuffer();
    const fileReader = new FileReader();

    const loadNext = () => {
      const start = currentChunk * CHUNK_SIZE;
      const end = start + CHUNK_SIZE >= file.size ? file.size : start + CHUNK_SIZE;

      fileReader.readAsArrayBuffer(file.slice(start, end));
    };

    fileReader.onload = (e: ProgressEvent<FileReader>) => {
      spark.append(e.target.result as ArrayBuffer);
      currentChunk++;

      if (currentChunk < chunks) loadNext();
      else {
        const hex = spark.end();
        resolve({ hex, base64: hexToBase64(hex) });
      }
    };

    fileReader.onerror = () => {
      return reject('Calculating file checksum failed');
    };

    loadNext();
  });
